module.exports = __webpack_public_path__ + "static/banner_2_mobile-188713347e8376967fe26ae939316285.png";